import { Col, Row, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { renderNoukiDisplay } from 'src/utils/helper';
import { NumberFormatter } from 'src/utils/number';
import { RowDetail } from 'src/components/common';

type Props = {
  item: Response.EstimatePrice['item'];
  queryTaxes?: Response.TaxesResponse['items'];
};

const ExpandedRowRender: React.FC<Props> = ({ item, queryTaxes }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Title level={1} className="mt-20 text_title">
        {t('pricing_page.estimate_results.price')}
      </Typography.Title>

      <div className="table_item container_estimate_results">
        <div className="row_item">
          <Row>
            <Col span={11}>
              <Typography.Title level={5}>
                {t('pricing_page.estimate_results.price_excluding_tax')}
              </Typography.Title>
            </Col>
            <Col span={7} className="text_price_center">
              <Typography.Text className="text_price">
                {NumberFormatter.format(Number(item?.marumeHanbaiGaku), 18)}
              </Typography.Text>
            </Col>
            <Col span={6} className="text_price_center">
              <Typography.Text>
                {item?.unitPrice?.split(' ')[1]}
              </Typography.Text>
            </Col>
          </Row>
        </div>

        <Row className="row_item" align="middle">
          <Col span={11}>
            <Typography.Title level={5}>
              {t('pricing_page.estimate_results.total_excluding_tax')}
            </Typography.Title>
          </Col>
          <Col span={7} className="text_price_center">
            <Typography.Text className="text_price custom_text_price">
              {NumberFormatter.format(Number(item?.marumeSogaku), 18)}
            </Typography.Text>
          </Col>
          <Col span={6} className="text_price_center">
            <Typography.Text className="total_textCny">
              ({item?.totalPrice?.split(' ')[1]})
            </Typography.Text>
          </Col>
        </Row>

        {item?.displayToFullTax && (
          <Row className="row_item" align="middle">
            <Col span={11}>
              <Typography.Title level={5}>
                {t('pricing_page.estimate_results.total_tax_included')}
              </Typography.Title>
            </Col>
            <Col span={7} className="text_price_center">
              <Typography.Text className="text_price custom_text_price total_including_tax">
                {NumberFormatter.format(Number(item?.marumeMitrGaku), 18)}
              </Typography.Text>
            </Col>
            <Col span={6} className="text_price_center">
              <Typography.Text className="text_currency">
                ({item?.totalPrice?.split(' ')[1]})
              </Typography.Text>
            </Col>
          </Row>
        )}

        {queryTaxes?.map((tax, index) => (
          <Row className="row_item" align="middle" key={index}>
            <Col span={11}>
              <Typography.Title level={5}>{tax?.taxName}</Typography.Title>
            </Col>
            <Col span={7} className="text_price_center">
              <Typography.Text className="text_price">
                {tax?.zeikin}
              </Typography.Text>
            </Col>
            <Col span={6} className="text_price_center">
              <Typography.Text>({tax?.sogakuTani})</Typography.Text>
            </Col>
          </Row>
        ))}
      </div>

      <Typography.Title level={1} className="mt-20 text_title">
        {t('pricing_page.estimate_results.quotation')}
      </Typography.Title>

      <div
        className="container_estimate_results table_item"
        // style={{ maxWidth: 418 }}
      >
        <RowDetail
          title={t('pricing_page.estimate_results.expiration_date')}
          value={item?.mitrYukoKigenb}
          layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
          rowClassName="row_item"
        />

        <RowDetail
          title={t('pricing_page.estimate_results.delivery_destination')}
          value={item?.nonyusm}
          layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
          rowClassName="row_item"
        />

        <RowDetail
          title={t('pricing_page.estimate_results.stock_status')}
          value={
            item?.zaikMeyasu !== 'EXTERNAL'
              ? item?.zaikMeyasu
              : t('pricing_page.estimate_results.stock_status_external')
          }
          layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
          rowClassName="row_item"
        />

        <RowDetail
          title={t('pricing_page.estimate_results.detail')}
          value={item?.options}
          layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
          rowClassName="row_item"
        />

        <RowDetail
          title={t('pricing_page.estimate_results.order_closing_time')}
          value={item?.taigaiSimeJikok}
          layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
          rowClassName="row_item"
        />

        <RowDetail
          title={t('pricing_page.estimate_results.delivery_date')}
          value={
            item?.noki !== 'EXTERNAL'
              ? item?.noki
              : renderNoukiDisplay(item?.noukiDisplay)
          }
          layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
          rowClassName="row_item"
        />
      </div>
    </>
  );
};

export default ExpandedRowRender;
